/* eslint-disable */
<template lang="html">
  <v-app id="inspire">
    <div
      class="display-1 
                d-flex 
                justify-center 
                text-center
                mt-12
                pt-4
                grey--text 
                text--darken-2"
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row wrap>
        <v-card
          class="mx-auto 
                  mb-4
                  mt-2"
          max-width="344"
          v-for="(product, index) in products"
          :key="index"
        >
          <v-img
            v-bind:src="product.prodImgUrl"
            :lazy-src="lazyImg"
            height="200px"
          ></v-img>

          <v-card-title style="word-break: normal;" class="text-center">
            <span style="margin: 0 auto" v-text="product.prodName"> </span>
          </v-card-title>
        </v-card>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
export default {
  data: () => ({
    name: "მოტოციკლეტის ლუბრიკანტები",
    text: "This is sash product",
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    lazyImg: require("@/assets/lazy_engine_oil.png"),
    products: [
      {
        prodName: "Gama 4T",
        prodImgUrl:
          "https://i2.wp.com/www.lubricantes-sash.com/wp-content/uploads/2018/08/4T_ESTER.jpg?zoom=1.25&w=930&ssl=1",
        prodLinkpass: ""
      }
    ]
  })
};
</script>
